

export const colorsHangup = {
    white: '#fff',
    blackColor: '#233b4f',
    hangUpRed: '#f13e44',
    hangUpBlue: '#46537f'
};

